/*
 * Created Date: 19-02-2023, 1:23:31 am
 * Author: Hai Tran
 * Email: you@you.you
 * -----
 * Last Modified: Thu Feb 23 2023
 * Modified By: Hai Tran
 * -----
 * Copyright (c) 2023 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import CoreInput from '@Core/Components/Input/CoreInput'
import { KeyboardArrowDown } from '@mui/icons-material'
import { Box, Button, Menu, MenuItem, Pagination, Typography } from '@mui/material'
import { useUpdateEffect } from 'ahooks'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
// import PropTypes from 'prop-types'

const TablePagination = props => {
	const { pageIndex, pageSize, total, fetchData, last_page, per_page, current_page, params, t } = props
	const [rowPerPages, setRowPerPages] = useState(pageSize ?? 10)
	const [page, setPage] = useState(pageIndex ?? 1)
	const [anchorEl, setAnchorEl] = useState(null)

	const handleClick = event => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	useUpdateEffect(() => {
		setValue('jump_to_page', page)
	}, [page])

	const open = Boolean(anchorEl)
	const { control, getValues, setValue } = useForm({
		defaultValues: {
			jump_to_page: pageIndex ?? null
		}
	})

	return (
		<Box className="flex flex-wrap items-center justify-between w-full px-10 my-10 md:flex-nowrap">
			<Box className="flex items-center justify-start w-auto mx-auto md:mx-0">
				<Typography>{t('table.row_per_page')}</Typography>
				<Button onClick={handleClick}>
					{rowPerPages} <KeyboardArrowDown />
				</Button>
				<Typography>{`${t('table.of_total')} ${total}`}</Typography>

				<Box sx={{ p: 2 }}>
					<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
						{[5, 10, 20, 50, 100]?.map((item, index) => {
							return (
								<MenuItem
									key={index}
									onClick={async () => {
										handleClose()
										const res = await fetchData({
											...params,
											size: item,
											page: 1
										})
										setPage(res?.page)
										setRowPerPages(item)
									}}
								>
									{item}
								</MenuItem>
							)
						})}
					</Menu>
				</Box>
			</Box>
			<Box className="flex w-full my-10 md:my-0 md:w-auto">
				<Box className="mx-auto">
					<Pagination
						color="primary"
						boundaryCount={0}
						onChange={(e, value) => {
							setPage(value)
							fetchData({
								...params,
								size: rowPerPages,
								page: value
							})
						}}
						page={pageIndex ?? 1}
						count={last_page ?? 1}
						showFirstButton
						showLastButton
					/>
				</Box>
			</Box>
			<Box className="flex items-center justify-end w-auto mx-auto md:mx-0">
				<Typography className="pr-8">{t('table.jump_to_page')}</Typography>
				<CoreInput
					control={control}
					type="number"
					name="jump_to_page"
					onKeyPress={ev => {
						if (ev.key === 'Enter') {
							const toPage = getValues('jump_to_page')
							if (toPage <= last_page && toPage > 0) {
								fetchData({
									...params,
									size: rowPerPages,
									page: toPage
								})
								setPage(toPage)
							} else {
								// errorMsg(t('message.page_not_found'))
							}
						}
					}}
					onBlur={() => setValue('jump_to_page', page)}
					className="w-60"
					size="small"
				/>
			</Box>
		</Box>
	)
}

// TablePagination.defaultProps = {}

// TablePagination.propTypes = {}

export default React.memo(TablePagination)
